// Style overrides are currently in javascript because we don't have CSS module support when server-side rendering.
// This will be refactored once we have our final CSS solution in place.
//@flow
const style = {
  form: {
    padding: 0,
    margin: 0,
  },
  'form > ul': {
    margin: 0,
    borderRadius: 0,
    boxShadow: 'none',
  },
  formFooter: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    boxShadow: 'none',
  },
};

export default style;
